import { useState } from 'react'

interface Filters {
  specialization: string[]
  experience: [number, number] | undefined
  job: string[]
}

const initialFilters: Filters = {
  specialization: [],
  experience: undefined,
  job: [],
}

export const useMakerFilter = () => {
  const [filters, setFilters] = useState<Filters>(initialFilters)

  const handleFilterChange = (
    key: keyof Filters,
    value: string | string[] | number[] | [number, number] | undefined,
  ) => {
    setFilters((prev) => {
      if (key === 'experience') {
        if (value === undefined || (Array.isArray(value) && value.length === 2)) {
          return { ...prev, [key]: value as [number, number] | undefined }
        }
        return prev
      }
      return { ...prev, [key]: value }
    })
  }

  return { filters, handleFilterChange }
}
